export default __webpack_public_path__ + "static/media/25555-middle.5cf6e04b.png";